module.exports = __webpack_public_path__ + "static/img/Maple Soapstone.7670ccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Maple Soapstone.jpg
// module id = H364
// module chunks = 0